import { Chip } from '@mui/material';
import React from 'react';

const CustomChip = (props) => {
  const {
    color,
    label,
    size = 'normal',
    icon,
    variant,
    className,
  } = props || {};

  return (
    <Chip
      label={label}
      className={className}
      color={color}
      variant={variant}
      size={size}
      icon={icon}
    />
  );
};

export default CustomChip;
